var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { BreadcrumbContext, BreadcrumbProvider, BreadcrumbSubheading } from '@sierralabs/core-ui';
import { flattenTree } from '../../common/utils/flattenTree';
import { useGetFileTreeById } from '../hooks/useGetFileTreeById';
import { useDocumentListPageContext } from '../DocumentListPageContext';
const DocumentBreadcrumbs = props => {
    return (React.createElement(BreadcrumbProvider, null,
        React.createElement(DocumentBreadcrumbsRoot, Object.assign({}, props))));
};
export const DocumentBreadcrumbsRoot = props => {
    const { fileId } = props, breadcrumbProps = __rest(props, ["fileId"]);
    const { basePath, toFilePath } = useDocumentListPageContext();
    const { clearBreadcrumbs, updateBreadcrumb } = useContext(BreadcrumbContext);
    const [root, setRoot] = useState();
    const { data, get } = useGetFileTreeById(fileId);
    const flatList = useMemo(() => {
        const flatList = [];
        if (root) {
            flattenTree(root, flatList, props => {
                const { child, hasValidLeafNode } = props;
                return hasValidLeafNode || child.id === fileId;
            });
        }
        return flatList;
    }, [fileId, root]);
    useEffect(() => {
        get();
    }, [get]);
    useEffect(() => {
        if (data) {
            const root = data.find(file => file.children && file.children.length > 0);
            setRoot(root);
        }
    }, [data]);
    useEffect(() => {
        clearBreadcrumbs();
        flatList.forEach((file, index) => {
            var _a;
            const path = file.isFolder
                ? `${basePath}/folder/${file.id}`
                : toFilePath(file.id);
            const breadcrumb = {
                index,
                path,
                label: file.isFolder
                    ? file.name || ''
                    : ((_a = file.task) === null || _a === void 0 ? void 0 : _a.key) || `DOC-${file.id}`
            };
            updateBreadcrumb(index, breadcrumb);
        });
    }, [basePath, flatList, clearBreadcrumbs, updateBreadcrumb, toFilePath]);
    return React.createElement(BreadcrumbSubheading, Object.assign({}, breadcrumbProps));
};
export default DocumentBreadcrumbs;
//# sourceMappingURL=DocumentBreadcrumbs.js.map